function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.83 3.672c.227.23.227.6 0 .83l-7.742 7.826a.576.576 0 01-.821 0L2.17 9.198a.591.591 0 010-.83.576.576 0 01.821 0l2.686 2.715 7.332-7.411a.576.576 0 01.82 0z",
  fill: "#2D2D2D"
});
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Check.svg";
export { SvgCheck as ReactComponent };